import React from 'react'
import ReactDOM from 'react-dom'
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { ConfigProvider } from 'antd'
import moment from 'moment'
import pt_BR from 'antd/lib/locale-provider/pt_BR'
import 'moment/locale/pt-br'
import 'cropperjs/dist/cropper.css'

import App from './App'
import configStore, { history } from './redux/config.store'
import { start, stop } from './redux/loader/loader.actions'
import * as serviceWorker from './serviceWorker'
import { load, logOut } from './redux/account/account.actions';

import './styles/antd.less'
import './styles/index.scss'

import {ClipboardService} from "./shared/services/ClipboardService";

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: "https://71c9a9cf832c43bfbc030f291024a33d@o360146.ingest.sentry.io/5406409",
    integrations: [
      new Integrations.BrowserTracing(),
    ],
    tracesSampleRate: 1.0,
    environment: process.env.REACT_APP_SENTRY_ENV,
  });
}

moment.locale('pt-br')

const store = configStore()

store.dispatch(start())
store.dispatch(load())
setTimeout(() => {
  store.dispatch(stop())
}, 1000)

ClipboardService().queryPermission()

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <React.Fragment>
        <ConfigProvider locale={pt_BR}>
          <App />
        </ConfigProvider>
      </React.Fragment>
    </ConnectedRouter>
  </Provider>, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
